export default {
  past_seven_days: 'Past 7 Days',
  past_three_months: 'Past 3 Months',
  previous_month: 'Past Month',
  this_month: 'This Month',
  this_year: 'This Year'
};